import styled from 'styled-components'

export const Container = styled.div`
  pre > pre {
    margin: 0
  }
`
